
import imgPremiosCO from '../assets/images/premios/premio-co.png'
import imgPremiosEC from '../assets/images/premios/premio-ec.gif'
import imgPremiosPE from '../assets/images/premios/premio-pe.png'
import imgPremiosBO from '../assets/images/premios/premio-bo.png';
import imgPremiosAR from '../assets/images/premios/premio-ar.png';
import imgPremiosDO from '../assets/images/premios/premio-do.png';
import imgPremiosPY from '../assets/images/premios/premio-py.png';

const premiosDic = {
    'es-CO': imgPremiosCO,
    'es-EC': imgPremiosEC,
    'es-BO': imgPremiosBO,
    'es-PE': imgPremiosPE,
    'es-AR': imgPremiosAR,
    'es-DO': imgPremiosDO,
    'es-PY': imgPremiosPY,
};


const premioProductImg = premiosDic.hasOwnProperty(process.env.LOCALE) ? premiosDic[process.env.LOCALE] : premiosDic["es-CO"];

export default premioProductImg;